import React from "react";
import useStoreState from "@/components/providers/useStoreState";
import { FORMS_FLAG } from "@/constants/FeatureFlags.mjs";
import useV2Feature from "@/hooks/useV2Feature";
import contextMenuActionRegistry from "@/services/ContextMenuActionRegistry";
import ClipboardStore from "@/stores/ClipboardStore";
import StageRightClickMenuConfig from "./configs/StageRightClickMenuConfig";
import RightClickMenu from "./RightClickMenu";

const stageMenuConfig = new StageRightClickMenuConfig();

/**
 * Stage-specific right-click context menu component that provides
 * all context-aware menu items for the design stage
 * @param {Object} props
 * @param {Object} props.menuState - Menu state from right-click detection
 * @param {Function} props.onClose - Callback to close the menu
 */
const StageRightClickMenu = ({ menuState, onClose }) => {
  const canPasteElements = useStoreState(ClipboardStore, ClipboardStore.canPasteElements);
  const isFormFieldsEnabled = useV2Feature(FORMS_FLAG);

  const handleActionSelect = async (actionName, actionContext) => {
    try {
      await contextMenuActionRegistry.executeAction(actionName, actionContext);
    } catch (error) {
      console.error("Failed to execute stage action:", error);
      // The action registry will handle error logging
    }
  };

  return (
    <RightClickMenu
      menuState={menuState}
      onClose={onClose}
      onSelect={handleActionSelect}
      menuConfig={stageMenuConfig}
      additionalContext={{ canPasteElements, isFormFieldsEnabled }}
      className="stage-right-click-menu"
    />
  );
};

export default StageRightClickMenu;
